import { render, staticRenderFns } from "./XActionButton.vue?vue&type=template&id=ac33e43c"
import script from "./XActionButton.vue?vue&type=script&lang=js"
export * from "./XActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports